module.exports = __webpack_public_path__ + "img/exam2.f855da81.svg";